import { withInitialValue } from "lib/graphql/with-initial-value"

export const IS_LOADING = Symbol.for("isLoading")

export function returnIsLoadingOnEachRequest() {
    return withInitialValue(IS_LOADING)
}
